import { element } from 'protractor';
import { Directive, Input, ElementRef } from '@angular/core';

let iqInputCount = 0;

@Directive({
  selector: '[iqInput]',
  host: {
    'class': 'iq-input',
    '[attr.id]' : 'id',
  }
})
export class InputDirective {

  protected _id: string;
  protected _uid = `iq-input-${iqInputCount++}`;

  constructor( private elementRef: ElementRef ) {
    this.id = this.id;
  }
  get inputType(): string {

    return this.elementRef.nativeElement.type;
  }

  @Input()
  get id(): string {  return this._id; }
  set id(value: string) { this._id = value || this._uid; }

}
